export const pluralize = (count, word, plural) => {
  if (count === 1) return word

  return plural
}
